import clsx from "clsx";

type AddOnPreviewImageProps = {
  src: string;
  alt: string;
  width: number;
  height: number;
};
export const AddOnPreviewImage = ({ src, alt, width, height }: AddOnPreviewImageProps) => (
  <img
    src={src}
    alt={alt}
    width={width}
    height={height}
    className={clsx(
      "rounded-2xl shrink-0 grow-0 border border-[rgba(23,25,25,0.08)] border-solid",
      "w-full h-auto",
      "md:w-auto md:h-auto"
    )}
  />
);
